<div class="l-footer">
  <div class="l-footer__top">
    <img src="./../../../../assets/img/footer-logo.png" alt="" class="c-pc" />
    <img
      src="./../../../../assets/img/footer-logo-sp.png"
      alt=""
      class="c-sp"
    />
    <h2 class="l-footer__top__title">JAPAN PHARMA INC.</h2>
  </div>
  <div class="l-footer__menu c-pc">
    <h2 class="c-title">LINKS</h2>
    <ul class="c-menu">
      <li>
        <a translate [href]="'/about' + getUrl()">{{ "link.menu.about" }}</a>
      </li>
      <li>
        <a translate [href]="'/service' + getUrl()">{{
          "link.menu.service"
        }}</a>
      </li>
      <!-- <li>
        <a translate [href]="'/management' + getUrl()">{{
          "link.menu.management"
        }}</a>
      </li> -->
      <li>
        <a translate [href]="'/contact' + getUrl()">{{
          "link.menu.contact"
        }}</a>
      </li>
      <li>
        <a
          href="https://www.linkedin.com/company/japan-pharma-inc/"
          target="_blank"
        >
          <img
            src="./../../../../assets/img/linkedin.png"
            alt="Hired at Linkin"
          />
        </a>
      </li>
      <li>
        <a translate [href]="getLawsLink()" target="_blank">
          {{ "link.menu.laws" }}
        </a>
      </li>
    </ul>
  </div>
  <div class="l-footer__menu__sp c-sp">
    <a
      href="https://www.linkedin.com/company/japan-pharma-inc/"
      target="_blank"
    >
      <img
        src="./../../../../assets/img/linkedin.png"
        alt="Hired at Linkin"
        class="c-sp"
      />
    </a>
  </div>
  <p class="l-footer__copyright">Copyright (c) 2022 eyes. All Right Reserved</p>
</div>
